<div
	class="kiosk-mode-container"
	[ngClass]="{ 'wait-in-line-wrapper': _activePassCollection.value.length > 0 && waitInLinePassesEnabled }"
	[ngStyle]="{ 'flex-direction': _activePassCollection.value.length > 0 ? (waitInLinePassesEnabled ? '' : 'column') : '' }">
	<div class="main-page-left">
		<div class="current-pass ds-p-25">
			<div [ngClass]="{ disabled: noFlyTimeActive }" class="typer-wrapper" (click)="openNoFlyTimeTooltip()">
				<div class="title">Create Pass</div>
				<sp-student-typer
					[disabled]="noFlyTimeActive"
					[width]="'377px'"
					[enableIdSearch]="enableIdSearch"
					[enableScanning]="enableIdScanning && !(kioskMode.checkInShowing$ | async)"
					[enableStudentSearch]="enableNameOrEmailSearch"
					[inputFocused]="inputFocused"
					tintColor="white"
					(focusEvent)="focusEvent()"
					(blurEvent)="blurEvent($event)"
					(onSelectStudent)="showMainForm($event)">
				</sp-student-typer>
				<p class="error-state" *ngIf="showError && inputBlurString && !inputFocused">
					<img class="right-arrow" [src]="'./assets/error-white.svg' | resolveAsset" alt="right arrow" /> {{ getPlaceholder() }}
					{{ inputBlurString }}.
				</p>
			</div>
		</div>
		<div *ngIf="!isWILRefreshEnabled" class="waitinline-passes pass-collection">
			<!-- If isWILenabled is true, this block will render -->
			<app-pass-collection
				*ngIf="waitInLinePassesEnabled"
				[waitInLine]="true"
				[forStaff]="true"
				[style.width]="'460px'"
				[passProvider]="waitingInLinePasses$"
				[title]="waitInLineTitle | async"
				[showProfilePictures]="showProfilePicture">
			</app-pass-collection>
		</div>

		<div class="class-info" *ngIf="waitInLinePassesEnabled && (waitingInLinePasses$ | async)?.length > 0 && isWILRefreshEnabled">
			<sp-collapsible-card [collapsible]="false">
				<div sp-collapsible-card-header class="coming-this-period-header">
					<span> Waiting In Line </span>
					<sp-wil-help-icon [roomPassLimit]="passLimits[currentLocation?.id]" [isBlocking]="wilBlocked$ | async"></sp-wil-help-icon>
				</div>
				<div collapsible-card-content style="width: 100%">
					<div class="student-list" style="padding-top: 32px">
						<sp-student-list-item
							*ngFor="let pass of waitingInLinePasses$ | async; let i = index"
							[student]="pass.student"
							[ordered]="pass.is_origin_line"
							[index]="i"
							(hovered)="hoveredWilPassId = $event ? pass.id : null"
							class="student-item">
							<div sp-student-list-item-right class="student-item-right-side">
								<sp-student-pass-info
									[pass]="pass"
									[passType]="'wait_in_line'"
									class="student-pass-info"
									(click)="homePageService.openPassDialog(pass, true, false)"
									(mousedown)="$event.stopPropagation()">
								</sp-student-pass-info>
							</div>
						</sp-student-list-item>
					</div>
				</div>
			</sp-collapsible-card>
		</div>
	</div>
	<div class="main-page-right" *ngIf="_activePassCollection.value.length > 0">
		<div class="active-passes" [style.margin]="waitInLinePassesEnabled ? '0 28px' : 'auto'">
			<app-pass-collection
				[isActive]="true"
				[forStaff]="true"
				[passProvider]="activeHallPasses$"
				[title]="'Active Passes'"
				[showProfilePictures]="showProfilePicture">
			</app-pass-collection>
		</div>
	</div>
</div>
